<template>
<div>
  <nav>
    <ul class="nav nav-pills">
      <li
        class="nav-item"
      >
        <router-link :to="{
            name: 'create_subscription'
          }"
          class="nav-link"
        >
          Create Subscription
        </router-link>
      </li>
      <li
        class="nav-item"
        v-if="subscriptionId"
      >
        <router-link :to="{
            name: 'edit_subscription',
            params: {
              subscriptionId: this.subscriptionId
            }
          }"
          class="nav-link"
        >
          Edit Subscription
        </router-link>
      </li>

      <li
        class="nav-item"
        v-if="this.$root.isAdmin"
      >
        <router-link :to="{
          name: 'import_subscriptions'
          }"
          class="nav-link"
        >
          Import Subscriptions
        </router-link>
      </li>

      <li
        class="nav-item"
        v-if="this.$root.isAdmin"
      >
        <router-link :to="{
          name: 'export_subscriptions'
          }"
          class="nav-link"
        >
          Export Subscriptions
        </router-link>
      </li>

      <li
        class="nav-item"
        v-if="this.$root.isAdmin"
      >
        <router-link :to="{
          name: 'subscription_stats'
          }"
          class="nav-link"
        >
          Stats
        </router-link>
      </li>
    </ul>
  </nav>
</div>
</template>

<script>
export default {
  props: ['subscriptionId']
}
</script>

<style scoped>
main nav {
  margin-bottom: 1em;
}

.nav {
  border-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SubscriptionNav.vue